import { AbstractIdbaModel } from '../abstract-idba-model';


export class Job extends AbstractIdbaModel {

  public override convertToModel(data: any): AbstractIdbaModel {
    return new Job(data);
  }

  public override display(self: any): string {
    return this.descricao;
  }
  public override displayCodigo(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override displayNome(self: any): string {
    throw new Error("Method not implemented.");
  }
  public override filter(value: string, objectList: any[]): any[] {
    throw new Error("Method not implemented.");
  }

  descricao: string
  codigo: string
  idTipoIntervalo: number
  quantidadeIntervalo: number
  ativo: boolean
  api: string
  idParametro: number
  parametro: string
  dataHoraProximaExecucao: Date
  dataHoraUltimaExecucao: Date

}
